import { useSession } from './session';

export const useIsSiteUser = () => {
	const { user } = useSession();
	return Boolean(user.siteUserId);
};
